// Import ALL assets exactly once and map them to filename-strings
import versusLogo from '../assets/profile_icons/versus.webp';

import icon_01 from '../assets/profile_icons/icon_01.webp';
import icon_02 from '../assets/profile_icons/icon_02.webp';
import icon_03 from '../assets/profile_icons/icon_03.webp';
import icon_04 from '../assets/profile_icons/icon_04.webp';
import icon_05 from '../assets/profile_icons/icon_05.webp';
import icon_06 from '../assets/profile_icons/icon_06.webp';
import icon_07 from '../assets/profile_icons/icon_07.webp';
import icon_08 from '../assets/profile_icons/icon_08.webp';
import icon_09 from '../assets/profile_icons/icon_09.webp';
import icon_10 from '../assets/profile_icons/icon_10.webp';

import heroBg from '../assets/profile_backgrounds/hero-background.webp';
import bg_01 from '../assets/profile_backgrounds/background_01.webp';
import bg_02 from '../assets/profile_backgrounds/background_02.webp';
import bg_03 from '../assets/profile_backgrounds/background_03.webp';
import bg_04 from '../assets/profile_backgrounds/background_04.webp';
import bg_05 from '../assets/profile_backgrounds/background_05.webp';
import bg_06 from '../assets/profile_backgrounds/background_06.webp';
import bg_07 from '../assets/profile_backgrounds/background_07.webp';
import bg_08 from '../assets/profile_backgrounds/background_08.webp';
import bg_09 from '../assets/profile_backgrounds/background_09.webp';
import bg_10 from '../assets/profile_backgrounds/background_10.webp';

// === Game covers available in repo (WebP - optimized) ===
import eaFcImg from '../assets/games/ea-fc.webp';
import codImg from '../assets/games/cod.webp';
import mkImg from '../assets/games/mario-kart.webp';
import csgoImg from '../assets/games/cs-go.webp';
import crImg from '../assets/games/clash-royale.webp';
import valorantImg from '../assets/games/valorant.webp';

export const imageMap = {
  // logo
  'versus.webp': versusLogo,

  // profile icons
  'icon_01.webp': icon_01,
  'icon_02.webp': icon_02,
  'icon_03.webp': icon_03,
  'icon_04.webp': icon_04,
  'icon_05.webp': icon_05,
  'icon_06.webp': icon_06,
  'icon_07.webp': icon_07,
  'icon_08.webp': icon_08,
  'icon_09.webp': icon_09,
  'icon_10.webp': icon_10,

  // backgrounds
  'hero-background.webp': heroBg,
  'background_01.webp': bg_01,
  'background_02.webp': bg_02,
  'background_03.webp': bg_03,
  'background_04.webp': bg_04,
  'background_05.webp': bg_05,
  'background_06.webp': bg_06,
  'background_07.webp': bg_07,
  'background_08.webp': bg_08,
  'background_09.webp': bg_09,
  'background_10.webp': bg_10,

  // games (Both slug keys and extension keys → robust lookups)
  'ea-fc': eaFcImg,
  'ea-fc.jpg': eaFcImg,
  'ea-fc.webp': eaFcImg,

  cod: codImg,
  'cod.jpg': codImg,
  'cod.webp': codImg,

  'mario-kart': mkImg,
  'mario-kart.jpg': mkImg,
  'mario-kart.webp': mkImg,

  'cs-go': csgoImg,
  'cs-go.jpg': csgoImg,
  'cs-go.webp': csgoImg,

  'clash-royale': crImg,
  'clash-royale.jpg': crImg,
  'clash-royale.webp': crImg,

  valorant: valorantImg,
  'valorant.jpg': valorantImg,
  'valorant.webp': valorantImg
};

// leichte Alias-Tabelle (falls die API/Seeds andere Schreibweisen liefern)
const ALIAS = {
  'ea fc': 'ea-fc',
  eafc: 'ea-fc',
  'call of duty': 'cod',
  'cod mw2': 'cod',
  'mario kart': 'mario-kart',
  csgo: 'cs-go',
  'cs:go': 'cs-go',
  'clash royale': 'clash-royale',
  'riot-valorant': 'valorant',
  'riot_games_valorant': 'valorant',
};

// Return import-URL for a given filename-key (with fallback)
// Now supports both static assets and dynamic MediaAsset URLs
export const getAsset = (name, fallback = 'versus.webp') => {
  if (!name) return imageMap[fallback];
  
  // If it's already a full URL (from MediaAsset), return as-is
  if (typeof name === 'string' && (name.startsWith('http://') || name.startsWith('https://') || name.startsWith('data:'))) {
    return name;
  }
  
  // Otherwise use static imageMap
  return imageMap[name] || imageMap[fallback];
};

// Try multiple candidates (coverKey, normalized slug with .jpg/.webp/.png, aliases)
// 🎯 Smart Game/Tournament Cover Resolver: URLs haben Priorität, dann statische Assets
export function getGameCoverSmart(game, coverKey, fallback = 'versus.webp', tournamentData = null) {
  // 🎯 1. Priorisiere Tournament-spezifische URLs (wenn Tournament-Objekt übergeben)
  if (tournamentData) {
    // Tournament Hero URL
    if (tournamentData.heroUrl && /^https?:\/\//i.test(tournamentData.heroUrl)) {
      return tournamentData.heroUrl;
    }
    
    // Tournament Cover Image
    if (tournamentData.coverImage && /^https?:\/\//i.test(tournamentData.coverImage)) {
      return tournamentData.coverImage;
    }
    
    // Tournament Image URL
    if (tournamentData.imageUrl && /^https?:\/\//i.test(tournamentData.imageUrl)) {
      return tournamentData.imageUrl;
    }
  }
  
  // 🎯 2. Prüfe ob game selbst ein Objekt mit URLs ist (für Game-Objekte)
  if (typeof game === 'object' && game) {
    // Game Hero URL
    if (game.heroUrl && /^https?:\/\//i.test(game.heroUrl)) {
      return game.heroUrl;
    }
    
    // Game Cover Image
    if (game.coverImage && /^https?:\/\//i.test(game.coverImage)) {
      return game.coverImage;
    }
    
    // Game Image URL
    if (game.imageUrl && /^https?:\/\//i.test(game.imageUrl)) {
      return game.imageUrl;
    }
    
    // Nutze game.key oder game.name als Fallback für statische Assets
    game = game.key || game.slug || game.name || game;
  }
  
  // 🎯 3. Prüfe ob coverKey bereits eine URL ist
  if (coverKey && /^https?:\/\//i.test(coverKey)) {
    return coverKey;
  }
  
  // 🎯 4. Fallback auf statische Assets (bestehende Logik)
  const norm = (v) =>
    String(v || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/_/g, '-');

  const cover = norm(coverKey);
  let slug = norm(game);
  if (ALIAS[slug]) slug = ALIAS[slug];

  const candidates = [
    cover,
    `${slug}.jpg`,
    `${slug}.webp`,
    `${slug}.png`,
    slug,
  ].filter(Boolean);

  for (const c of candidates) {
    if (imageMap[c]) return imageMap[c];
  }
  
  // 🎯 5. Finaler Fallback
  return imageMap[fallback] || imageMap['hero-background.webp'] || '';
}

// Avatar helpers - now supports MediaAsset URLs
export const getAvatarForUser = (user) => {
  const name = user?.profileIcon;
  if (!name) return getAsset('versus.webp'); // Default fallback
  
  // If profileIcon is already a full URL from MediaAsset, use it directly
  if (typeof name === 'string' && (name.startsWith('http://') || name.startsWith('https://') || name.startsWith('data:'))) {
    return name;
  }
  
  // Handle legacy asset keys and provide fallbacks for standard assets
  if (name === 'versus.webp' || name === 'versus') {
    return getAsset('versus.webp');
  }
  
  // Otherwise use getAsset for static assets
  return getAsset(name) || getAsset('versus.webp');
};

// Background helpers - now supports MediaAsset URLs
export const getBackgroundForUser = (user) => {
  const name = user?.profileBackground;
  if (!name) return getAsset('hero-background.webp'); // Default fallback
  
  // If profileBackground is already a full URL from MediaAsset, use it directly
  if (typeof name === 'string' && (name.startsWith('http://') || name.startsWith('https://') || name.startsWith('data:'))) {
    return name;
  }
  
  // Handle legacy asset keys and provide fallbacks for standard assets
  if (name === 'hero-background.webp' || name === 'hero-background') {
    return getAsset('hero-background.webp');
  }
  
  // Otherwise use getAsset for static assets
  return getAsset(name) || getAsset('hero-background.webp');
};

export const initialsFromUsername = (username = '') =>
  (username.trim()[0] || '?').toUpperCase();